"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GIFRectangle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GIFRectangle_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.191 10.638c-.49 0-.898-.1-1.225-.301a1.906 1.906 0 0 1-.728-.868C2.079 9.091 2 8.643 2 8.125c0-.55.086-1.02.259-1.407a2.01 2.01 0 0 1 .77-.903c.336-.21.747-.315 1.232-.315.261 0 .509.028.742.084.233.056.443.13.63.224l-.315.812a1.645 1.645 0 0 0-.462-.182 1.96 1.96 0 0 0-.49-.063c-.303 0-.555.068-.756.203a1.2 1.2 0 0 0-.448.595 2.616 2.616 0 0 0-.147.931c0 .336.042.63.126.882.089.252.222.448.399.588.177.135.401.203.672.203.103 0 .198-.007.287-.021.089-.014.175-.03.259-.049V8.594h-.693v-.84h1.61v2.597c-.243.107-.48.182-.714.224-.233.042-.49.063-.77.063ZM6.617 10.568v-.7l.973-.112V6.382l-.973-.112v-.7h2.94v.7l-.994.112v3.374l.994.112v.7h-2.94ZM10.745 5.57v4.998h.98V8.622h2.065v-.875h-2.065V6.445h2.17V5.57h-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7Zm2-1h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GIFRectangle_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GIFRectangle;
exports["default"] = _default;